import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { UserStatus } from "../../generated/lib-domain/user";
import * as aa from "../../generated/UserAPIAgent";
import { URL_PATHS } from "../../routes";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

interface PaymentMakeRouteProps extends RouteProps {
    user: aa.User | null;
    children: JSX.Element;
}

const PaymentMakeRoute = (props: PaymentMakeRouteProps) => {
    const { children, user, ...rest } = props;
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return (
        <Route
            {...rest}
            render={({ location }) => {
                if (
                    !user &&
                    ![UserStatus.Created, UserStatus.Active].includes(
                        user.status
                    )
                ) {
                    return (
                        <Redirect
                            to={{
                                pathname: URL_PATHS.login(),
                                state: { from: location }
                            }}
                        />
                    );
                }
                return children;
            }}
        />
    );
};

export default PaymentMakeRoute;
